module.exports = __webpack_public_path__ + "img/login-bg-top.cf0b6c35.png";